var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"layout",attrs:{"id":"app"}},[_c('router-view'),(_vm.pop_status)?_c('div',{staticClass:"pop_model"},[_c('img',{attrs:{"src":require("../src/assets/loading.gif"),"alt":""}})]):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }